import usePrivateAxios from "@/common/api/usePrivateAxios"
import { MaintenanceSpecialtyValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/maintenanceSpecialty.schema"
import { useMutation } from "@tanstack/react-query"

interface UseCreateEstablishmentCompanyMaintenanceSpecialtyProps {
  establishmentCompanyId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useCreateEstablishmentCompanyMaintenanceSpecialty = ({
  establishmentCompanyId,
  onSuccess,
  onError,
}: UseCreateEstablishmentCompanyMaintenanceSpecialtyProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentCompanyMaintenanceSpecialty', establishmentCompanyId],
    mutationFn: (data: MaintenanceSpecialtyValidationSchema) => {
      const payload = {
        maintenance_specialty_attributes: {
          system_part_id: data.system_part?.value,
          action_id: data.action?.value,
        },
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompanyId}/update_maintenance_models`, {
        company: payload,
      });
    },
    onSuccess,
    onError,
  });
}
